import React, { useState } from 'react'
import DatePicker, { registerLocale } from 'react-datepicker'
import { timeConverter2 } from '../../Online-schedule/components/functions'
import ru from 'date-fns/locale/ru'
import 'react-datepicker/dist/react-datepicker.css'
import './DataPickerSplit.scss'
import { localisationMaster } from 'Localisation/Localisation'
import DatePickerWrapper from 'components/UI/DatePickerWrapper'
import CustomSelect from 'components/UI/CustomSelect/CustomSelect'
import { monthsData } from 'components/UI/Calendar/utils.js'
import { years } from 'components/UI/Calendar/utils.js'

registerLocale('ru', ru)

export default function DataPickerSplit(props) {
  const [startDate, setStartDate] = useState(new Date())
  const [endDate, setEndDate] = useState(new Date())

  const changeStartHandler = (date) => {
    props.objectChangeHandler(timeConverter2(date), 'date_from')
    setStartDate(date)
  }
  const changeEndHandler = (date) => {
    props.objectChangeHandler(timeConverter2(date), 'date_until')
    setEndDate(date)
  }

  return (
    <DatePickerWrapper>
      <div className='dataPickerSplit react-datepicker-custom'>
        <DatePicker
          disabled={props.disableFrom}
          renderCustomHeader={({ date, changeYear, changeMonth }) => (
            <div className='border-select'>
              <div className='custom-header-select'>
                <div className='select-month'>
                  <div className='date-name'>Month</div>
                  <CustomSelect
                    options={monthsData}
                    onSelect={(option) =>
                      changeMonth(monthsData.indexOf(option))
                    }
                    defaultValue={monthsData[date.getMonth()]}
                    dropdownMaxHeight={'250px'}
                  />
                </div>
                <div className='select-year'>
                  <div className='date-name'>Year</div>
                  <CustomSelect
                    options={years}
                    onSelect={(option) => changeYear(option)}
                    defaultValue={date.getFullYear()}
                    dropdownMaxHeight={'250px'}
                  />
                </div>
              </div>
            </div>
          )}
          selected={new Date(props.returnValue('date_from')) || startDate}
          onChange={(date) => changeStartHandler(date)}
          minDate={props.minDate || null}
          selectsStart
          endDate={
            props.returnValue('date_until') !== undefined
              ? new Date(props.returnValue('date_until'))
              : endDate
          }
          locale='ru'
          dateFormat='dd.MM.yyyy'
          peekNextMonth
          showMonthDropdown
          showYearDropdown
          dropdownMode='select'
        />
        <div className='dataPickerSplit__middle'>
          {localisationMaster('text-11', 'filter')}
        </div>
        <DatePicker
          renderCustomHeader={({ date, changeYear, changeMonth }) => (
            <div className='border-select'>
              <div className='custom-header-select'>
                <div className='select-month'>
                  <div className='date-name'>Month</div>
                  <CustomSelect
                    options={monthsData}
                    onSelect={(option) =>
                      changeMonth(monthsData.indexOf(option))
                    }
                    defaultValue={monthsData[date.getMonth()]}
                    dropdownMaxHeight={'250px'}
                  />
                </div>
                <div className='select-year'>
                  <div className='date-name'>Year</div>
                  <CustomSelect
                    options={years}
                    onSelect={(option) => changeYear(option)}
                    defaultValue={date.getFullYear()}
                    dropdownMaxHeight={'250px'}
                  />
                </div>
              </div>
            </div>
          )}
          selected={
            props.returnValue('date_until') === undefined
              ? endDate
              : props.returnValue('date_until') === null
                ? null
                : new Date(props.returnValue('date_until'))
          }
          onChange={(date) => changeEndHandler(date)}
          selectsEnd
          startDate={
            props.returnValue('date_from') !== undefined
              ? new Date(props.returnValue('date_from'))
              : startDate
          }
          minDate={
            props.returnValue('date_from') !== undefined
              ? new Date(props.returnValue('date_from'))
              : startDate
          }
          locale='ru'
          dateFormat='dd.MM.yyyy'
          popperPlacement='bottom-end'
          peekNextMonth
          showMonthDropdown
          showYearDropdown
          dropdownMode='select'
        />
      </div>
    </DatePickerWrapper>
  )
}
